export default __webpack_public_path__ + "static/media/thai.28786281.jpg";